export default __webpack_public_path__ + "static/media/gradebook.14fe0adb.png";